import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Hammer, MessageSquare, Plus, ShieldCheck, Zap } from "lucide-react";
import Layout from "@/components/Layout";
import { trackBeginListing } from "@/lib/analytics";

const STEPS = [
  {
    icon: Plus,
    title: "Vlož inzerát",
    text: "Po registraci a ověření emailu vložíš inzerát zdarma. Max 20 fotek, výrobní číslo, EAN.",
  },
  {
    icon: ShieldCheck,
    title: "Ověření kontaktu",
    text: "Každý inzerent ověří email — méně podvodů, víc reálných obchodů. (SMS verifikace bude přidána s rostoucí komunitou.)",
  },
  {
    icon: MessageSquare,
    title: "Komunikuj přes chat nebo email",
    text: "U každého inzerátu odpovědní formulář a online chat – text, fotky i hlasové zprávy.",
  },
  {
    icon: Zap,
    title: "TOPuj za 49 Kč",
    text: "Posuneš inzerát na první pozici. Konkurence tě může přebít dalším topnutím.",
  },
];

const FAQ = [
  { q: "Stojí inzerování něco?", a: "Ne. Vkládání i prohlížení je zdarma. Platíš jen za TOPování (49 Kč/inzerát/14 dní)." },
  { q: "Co mohu prodávat?", a: "Stavební materiál, ruční i elektrické nářadí, stavební stroje, lešení, bednění, zahradní techniku a ostatní." },
  { q: "Jak chat funguje?", a: "Po kliknutí na 'Otevřít chat' se otevře konverzace (text, fotky, hlas). E-mailové upozornění přijde jen když druhá strana není v chatu: prodejci, když mu někdo napíše a není online, a tobě, když odejdeš (zavřeš prohlížeč) a prodejce odepíše. Po každé další zprávě v té samé chvíli e-mail nechodí. Když chat opustíš a zůstaneš na STAVBOŠ, zůstane dole okno, dokud nezavřeš prohlížeč." },
  { q: "Kde najdu řemeslníka?", a: "Stavboš je propojen s portálem CraftBolt – v každém inzerátu i v patičce je odkaz." },
];

export default function HowItWorksPage() {
  return (
    <Layout>
      <div className="max-w-4xl">
        <h1 className="stb-h text-4xl text-[#0E0E0E]">Jak to funguje</h1>
        <p className="text-[#0E0E0E] mt-2 max-w-2xl">
          STAVBOŠ je stavební bazar a online inzerce pro stavebnictví a vše s tím spojené.
          Věříme, že všichni inzerující i kupující budou maximálně spokojení. Podněty
          na vylepšení můžete zasílat e-mailem na{" "}
          <a href="mailto:stavbos@post.cz" className="stb-link">stavbos@post.cz</a>.
          Děkujeme.
        </p>

        <ol className="mt-6 grid sm:grid-cols-2 gap-3">
          {STEPS.map((s, i) => (
            <li key={i} className="stb-card p-4 relative" data-testid={`how-step-${i}`}>
              <span className="stb-rivet" style={{ top: 4, left: 4 }} />
              <span className="stb-rivet" style={{ top: 4, right: 4 }} />
              <s.icon size={26} className="text-[#FF6B00] mb-2" />
              <h3 className="stb-h text-xl text-white">{i + 1}. {s.title}</h3>
              <p className="text-[#A3A3A3] text-sm mt-1">{s.text}</p>
            </li>
          ))}
        </ol>

        <h2 className="stb-h text-3xl text-[#0E0E0E] mt-10">Časté dotazy</h2>
        <div className="mt-3 space-y-3">
          {FAQ.map((f, i) => (
            <div key={i} className="stb-card p-4" data-testid={`faq-item-${i}`}>
              <h3 className="stb-h text-lg text-white inline-flex items-center gap-2">
                <CheckCircle2 size={16} className="text-[#FF6B00]" />
                {f.q}
              </h3>
              <p className="text-[#A3A3A3] mt-1">{f.a}</p>
            </div>
          ))}
        </div>

        <div className="stb-card p-5 mt-10 relative" data-testid="cta-block">
          <span className="stb-rivet" style={{ top: 4, left: 4 }} />
          <span className="stb-rivet" style={{ top: 4, right: 4 }} />
          <span className="stb-rivet" style={{ bottom: 4, left: 4 }} />
          <span className="stb-rivet" style={{ bottom: 4, right: 4 }} />
          <h3 className="stb-h text-2xl text-[#FF6B00] inline-flex items-center gap-2">
            <Hammer size={22} /> Začni inzerovat
          </h3>
          <p className="text-[#A3A3A3] mt-1">Vlož svůj první inzerát zdarma.</p>
          <Link
            to="/novy-inzerat"
            className="stb-btn stb-btn-primary mt-3 inline-flex"
            onClick={() => trackBeginListing({ source: "how_it_works" })}
          >
            <Plus size={14} /> Vložit inzerát
          </Link>
        </div>
      </div>
    </Layout>
  );
}
